import GalleryCard from 'components/GalleryCard';
import { SectionTitle } from 'components/Section';

type Props = {
    gallery: Gallery;
};

export const GalleryBlock = ({ gallery }: Props) => {
    return (
        <>
            <SectionTitle level={2} title="Galeria" url={`/galerie`} />
            <GalleryCard
                images={gallery.images}
                title={gallery.title}
                category={gallery.category}
                slug={gallery.seoSlug}
            />
        </>
    );
};

export default GalleryBlock;
